<template>
	<div class="menu-wrapper">
		<div class="header" @click="onClickHeader">
			<div v-if="darken">
				<h1>{{ welcomeText }}</h1>
			</div>
			<div v-else>
				<h1 v-bind:style="{ backgroundColor: 'transparent' }">
					{{ welcomeText }}</h1>
			</div>
		</div>

<!--
	@mouseover="menuVisible = true"
	@mouseout="menuVisible = false"
-->
		<div class="menu"
				@click="toggleMenu"
				>

			<div v-if="darken">
				<div class="menu-icon-wrapper">
					<MenuIcon class="menu-icon"/>
				</div>
			</div>
			<div v-else>
				<div class="menu-icon-wrapper"
					v-bind:style="{ backgroundColor: 'transparent' }">
					<MenuIcon class="menu-icon"/>
				</div>
			</div>

			<div v-if="darken">
				<transition name="menutransition">
					<ul class="menu-items-wrapper" v-show="menuVisible">
						<li class="transition-center" v-for="menuItem in menuList" :key="menuItem.text">
							<router-link :to="menuItem.link">{{ menuItem.text }}</router-link>
						</li>
					</ul>
				</transition>
			</div>
			<div v-else>
				<transition name="menutransition">
					<ul class="menu-items-wrapper" 
							v-show="menuVisible"
							v-bind:style="{ backgroundColor: 'transparent' }">
						<li class="transition-center" v-for="menuItem in menuList" :key="menuItem.text">
							<router-link :to="menuItem.link">{{ menuItem.text }}</router-link>
						</li>
					</ul>
				</transition>
			</div>
		</div>
	</div>		
</template>

<script>

	import MenuIcon from "../icons/MenuIcon.vue";

	export default {
		name: "Navigation",
		components: {
			MenuIcon
		},
		data() {
			return {
				welcomeText: 'TABI PHOTOGRAPHY',
				menuList: [
					{ text: 'About', link: 'about' },
					{ text: 'Portfolio', link: 'portfolio' },
//					{ text: 'Workshops', link: 'about' },
//					{ text: 'Store', link: 'about' },
					{ text: 'Contact', link: 'contact' }
				],
				menuVisible: false
			};
		},
		props: {
			darken: false
		},
		methods: {
			toggleMenu: function() {
				this.menuVisible = !this.menuVisible;
			},
			onClickHeader: function() {
				this.$router.push('/');
			}
		}
	}

</script>

<style lang="scss" scoped>

	$menu-background-color: #282828d0;
	$font-color: #f0f0f0;
	$font-hover-color: #fff;

	.menu-wrapper {
		position: absolute;
		width: 100%;
		font-size: 1.3rem;
		text-align: left;
	}

	.header {
		cursor: pointer;
	}

	h1 {
		font-size: 1.5rem;
		color: $font-color;
		padding: 1rem 0 0rem 1rem;
		font-weight: 100;
		background-color: $menu-background-color;
	}

	.menu {
		width: 100%;
		color: $font-color;
		text-align: left;
	}

	.menu-icon-wrapper {
		margin-left: 0;
		width: 100%;
		padding-left: 0rem;
		background-color: $menu-background-color;
	}

	.menu-icon {
		padding-left: 1rem;
		width: 1.05rem;
	}

	.menu-items-wrapper {
		width: 100%;
		padding-left: 1rem;
		background-color: $menu-background-color;
	}

	ul {
		list-style-type: none;
		padding-left: 0;
	}

	li {
		color: $font-color;
	}

	/* router-link generates <a> */
	a {
		color: $font-color;
		text-decoration: none;
	}

	a:hover, li:hover {
		color: $font-hover-color;
		margin-left: 0.2rem;
		cursor: pointer;
		font-weight: 400;
	}

	/* Fade transition */
	.menutransition-enter-active,
	.menutransition-leave-active {
		transition: all 0.8s ease;
	}

	.menutransition-enter,
	.menutransition-leave-to {
		opacity: 0;
	}


	@media only screen and (min-width: 600px) {
		.menu-icon {
			width: 1.3rem;
		}

		h1 {
			font-size: 2rem;
		}
	}

</style>




// WEBPACK FOOTER //
// src/components/Navigation.vue